import { useFormContext } from 'react-hook-form';

import { useIsExisting, useSaveStoreSelector } from 'pages/audience/shared/save/hooks';
import { SaveForm } from 'types/pages/audience-builder/shared/save';

export const useOrderTypeConfiguration = () => {
  const { control } = useFormContext<SaveForm>();
  const disabled = useIsExisting();
  const saveTo = useSaveStoreSelector(({ saveTo }) => saveTo);

  return { control, disabled: disabled || saveTo };
};
